<template>
  <symbol
    id="pinterest"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 1.478A8.516 8.516 0 0 1 18.522 10 8.516 8.516 0 0 1 10 18.522a8.533 8.533 0 0 1-2.477-.366c.35-.584.8-1.418.98-2.107.164-.408.543-2.049.543-2.049.284.517 1.114.977 1.999.977 2.63 0 4.528-2.42 4.528-5.427 0-2.883-2.353-5.04-5.38-5.04-3.765 0-5.764 2.528-5.764 5.28 0 1.28.68 2.877 1.77 3.38.166.077.254.044.292-.116.03-.122.177-.714.243-.99a.262.262 0 0 0-.06-.25C6.313 11.334 6 10.573 6 9.824 6 7.898 7.48 6 10 6c2.106 0 3.607 1.497 3.607 3.586 0 2.36-1.192 3.996-2.742 3.996-.865 0-1.498-.709-1.292-1.578.246-1.036.723-2.155.723-2.904 0-.67-.296-1.229-1.104-1.229-.876 0-1.58.905-1.58 2.129 0 .762.262 1.333.262 1.333s-.865 3.608-1.023 4.289c-.159.68-.116 1.596-.05 2.278-3.123-1.233-5.323-4.321-5.323-7.9A8.516 8.516 0 0 1 10 1.478zm0-.811C4.85.667.667 4.85.667 10S4.85 19.333 10 19.333 19.333 15.15 19.333 10 15.15.667 10 .667z"
    />
  </symbol>
</template>
